export default "__VITE_ASSET__7J3E4gBv__"